export default __webpack_public_path__ + "static/media/mandelbrot-set.e19f7a51.gif";